export const initialPeriod = {
  from: '',
  to: '',
};

const eventsPeriods = (state, action) => {
  switch (action.type) {
    case 'DASHBOARD_ADD_PERIOD':
      return {
        ...state,
        periods: state.periods.concat([initialPeriod]),
      };

    case 'DASHBOARD_DELETE_PERIOD':
      return {
        ...state,
        periods: state.periods.filter((period, index) => action.index !== index),
      };

    case 'DASHBOARD_SET_PERIOD':
      return {
        ...state,
        periods: state.periods.map((period, index) =>
          action.index === index
            ? {
                from: action.from,
                to: action.to,
              }
            : period
        ),
      };

    case 'DASHBOARD_SET_SHOW_PERIODS':
      return {
        ...state,
        isShow: action.value,
      };

    default:
      return state;
  }
};

export default eventsPeriods;
